// extracted by mini-css-extract-plugin
export default {"mainContainer":"weather_mainContainer__5eC+Q","linkToHistoricalWeather":"weather_linkToHistoricalWeather__tQHPT"};